import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'essential-system',
    templateUrl: './essential-system.component.html',
    styleUrls: ['./essential-system.component.scss']
})
export class EssentialSystemComponent implements OnInit {

    @Input() heading: string = 'Essential System';
    @Input() slogan: string = 'Efficient Homes, Holiday Homes, Small Businesses';
    @Input() headerCssClass: string = 'p-3';

    @Input() showImage: boolean = true;
    @Input() showHeading: boolean = false;
    @Input() showEmpty: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
    }
}
